import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { UserService } from '../../services/user.service';
import { ThemeService } from '../../services/theme.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { isPlatformBrowser, NgIf, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { AuthButtonsComponent } from '../auth-buttons/auth-buttons.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { environment } from '../../environments/environment';
import { Apps } from '../../interfaces/apps.interface';

@Component({
  selector: 'wm-libs-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatSidenavModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    AuthButtonsComponent,
    RouterLink,
    RouterLinkActive,
    HeaderComponent,
    NgClass,
    FooterComponent,
    // ViewDashboardLayoutComponent,
    TranslateModule,
  ],
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  isDashboard$ = false;
  @ViewChild('sidenav') sidenav!: MatSidenav;
  private authSubscription: Subscription;
  private themeSubscription: Subscription;
  private navigationSubscription!: Subscription;
  isAuth = false;
  isDarkMode$!: boolean;
  accesstoken: string | null = null;
  loaded = false;
  env = environment;
  @Input() app!: Apps;
  @Input() balance!: number;

  constructor(private router: Router, private userService: UserService, private themeService: ThemeService, private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: string) {
    this.authSubscription = this.userService.isAuthenticated$.subscribe((status) => {
      this.isAuth = status;
    });
    this.themeSubscription = this.themeService.isDarkMode$.subscribe((isDarkMode) => {
      this.isDarkMode$ = isDarkMode;
    });
  }

  onAuthButtonClick() {
    this.sidenav.close();
  }

  ngOnInit() {
    this.navigationSubscription = this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.isDashboard$ = event.url.startsWith('/main');

      if (isPlatformBrowser(this.platformId)) {
        const url = window.location.href;
        const urlParams = new URLSearchParams(url.split('?')[1]);
        this.accesstoken = urlParams.get('accesstoken') || '';
      }

      this.loaded = true;
    });
  }

  ngOnDestroy() {
    if (this.authSubscription) this.authSubscription.unsubscribe();
    if (this.themeSubscription) this.themeSubscription.unsubscribe();
    if (this.navigationSubscription) this.navigationSubscription.unsubscribe();
  }
}
